export default "__VITE_ASSET__CTEeP32O__"